import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/impostazioniCpa';
import { selectors, DEFAULT_STATE } from '../reducers/impostazioniCpa';
import api from '../apis/impostazioniCpa';

const sagas = helper.createSagas(
    'impostazioniCpa',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
